import moment from "moment"
import { divideInNIntegers } from "../../../common/mathHelper"
import { backGroundColor } from "../../../common/helper"

export const reportOptionSum = [
    { Option: 'Pay Type and Source', optionId: 1 },
    { Option: 'Only Summary', optionId: 2 },
    { Option: 'Branch Summary', optionId: 3 },
]
export const reportOptionDet = [
    { Option: 'LR Wise Detailed Report', optionId: 1 },
]
export const bookingTypes = [
    { Type: 'Online And Offline', typeId: 0 },
    { Type: 'Online Bookings', typeId: 1 },
    { Type: 'Offline Bookings', typeId: 2 },
]
export const receiveTypes = [
    { Type: 'All Received', typeId: 0 },
    { Type: 'Dest. Received', typeId: 1 },
]
export const colors = ["#fff", '#D0F1D2', '#FFE0EA', '#FFFDAF', '#FFE0BD', '#E2E3F3', '#E8FAE9', '#FFEFF4', '#C3F8FF', '#FFFDAF', '#EEEEF8',]
export const LRWiseDetColumns = [
    { headerName: 'Sr\nNo.', exportHead: 'Sr\nNo.', field: 'SN', xlCol: { dataType: 'number', dataFormatter: null }, align: "left" },
    { headerName: 'LR No-\nMan. LR No.', exportHead: 'LR No-\nMan. LR No.', field: 'LR', xlCol: { dataType: 'string', dataFormatter: null }, align: "left" },
    { headerName: 'Chln No.\nBill No.', exportHead: 'Chln No.\nBill No.', field: 'ChBill', xlCol: { dataType: 'string', dataFormatter: null }, align: "left" },
    { headerName: 'Disp. Date\nDisp. Time', exportHead: 'Disp. Date\nDisp. Time', field: 'DispDT', xlCol: { dataType: 'string', dataFormatter: null }, align: "left" },
    { headerName: 'Rcvd. Date\nRcvd. Time', exportHead: 'Rcvd. Date\nRcvd. Time', field: 'RcvdDT', xlCol: { dataType: 'string', dataFormatter: null }, align: "left" },
    { headerName: 'Veh. No\nDrvr. No', exportHead: 'Veh. No\nDrvr. No', field: 'VD', xlCol: { dataType: 'string', dataFormatter: null }, align: "left" },
    { headerName: 'Src. Branch\nDest. Branch', exportHead: 'Src. Branch\nDest. Branch', field: 'SBDB', xlCol: { dataType: 'string', dataFormatter: null }, align: "left" },
    { headerName: 'Disp.City\nDisp.Br', exportHead: 'Disp.City\nDisp.Br', field: 'DispCityBr', xlCol: { dataType: 'string', dataFormatter: null }, align: "left" },
    { headerName: 'Sndr.\nDetails', exportHead: 'Sndr.\nDetails', field: 'SD', xlCol: { dataType: 'string', dataFormatter: null }, align: "left" },
    { headerName: 'Rcvr.\nDetails', exportHead: 'Rcvr.\nDetails', field: 'RcvdD', xlCol: { dataType: 'string', dataFormatter: null }, align: "left" },
    { headerName: 'Pymt.\nType.', exportHead: 'Pymt.\nType.', field: 'PaymentType', xlCol: { dataType: 'string', dataFormatter: null }, align: "left" },
    { headerName: 'Cons. Type', exportHead: 'Cons. Type', field: 'ItemType', xlCol: { dataType: 'string', dataFormatter: null, halign: "left" }, align: "left" },
    { headerName: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'NOP', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
    { headerName: 'Frt.\nChrg', exportHead: 'Frt.\nChrg', field: 'Freight', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
    { headerName: 'Cart.\nChrg', exportHead: 'Cart.\nChrg', field: 'Cartage', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
    { headerName: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'Hamali', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
    { headerName: 'Oth.\nChrg', exportHead: 'Oth.\nChrg', field: 'OtherChg', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
    { headerName: 'Bkg.\nGST', exportHead: 'Bkg.\nGST', field: 'ServiceTaxAmount', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
    { headerName: 'Val.\nChrg', exportHead: 'Val.\nChrg', field: 'Valuation', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
    { headerName: 'Net.\nAmt.', exportHead: 'Net.\nAmt.', field: 'NetAmount', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },

]
export const LRWiseDetManageColumns = [
    {
        id: 1, header: 'Sr\nNo.', exportHead: 'Sr\nNo.', field: 'SN', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 40, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "left"
    },
    {
        id: 2, header: 'LR No-\nMan. LR No.', exportHead: 'LR No-\nMan. LR No.', field: 'LR', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "left"
    },
    {
        id: 3, header: 'Chln No.\nBill No.', exportHead: 'Chln No.\nBill No.', field: 'ChBill', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "left"
    },
    {
        id: 4, header: 'Disp. Date\nDisp. Time', exportHead: 'Disp. Date\nDisp. Time', field: 'DispDT', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "left"
    },
    {
        id: 5, header: 'Rcvd. Date\nRcvd. Time', exportHead: 'Rcvd. Date\nRcvd. Time', field: 'RcvdDT', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "left"
    },
    {
        id: 6, header: 'Veh. No\nDrvr. No', exportHead: 'Veh. No\nDrvr. No', field: 'VD', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "left"
    },
    {
        id: 7, header: 'Src. Branch\nDest. Branch', exportHead: 'Src. Branch\nDest. Branch', field: 'SBDB', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "left"
    },
    {
        id: 8, header: 'Disp.City\nDisp.Br', exportHead: 'Disp.City\nDisp.Br', field: 'DispCityBr', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "left"
    },
    {
        id: 9, header: 'Sndr.\nDetails', exportHead: 'Sndr.\nDetails', field: 'SD', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: false, isDefault: false, isSelected: true, align: "left"
    },
    {
        id: 10, header: 'Rcvr.\nDetails', exportHead: 'Rcvr.\nDetails', field: 'RcvdD', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: false, isDefault: false, isSelected: true, align: "left"
    },
    {
        id: 11, header: 'Pymt.\nType.', exportHead: 'Pymt.\nType.', field: 'PaymentType', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "left"
    },
    {
        id: 12, header: 'Cons. Type', exportHead: 'Cons. Type', field: 'ItemType', xlCol: { dataType: 'string', dataFormatter: null, halign: "left" }, pdfColSx: {
            fontSize: 16, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: false, isDefault: false, isSelected: true, align: "left"
    },
    {
        id: 13, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'NOP', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "right"
    },
    {
        id: 14, header: 'Frt.\nChrg', exportHead: 'Frt.\nChrg', field: 'Freight', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
        }, isMandatory: false, isDefault: false, isSelected: true, align: "right"
    },
    {
        id: 15, header: 'Cart.\nChrg', exportHead: 'Cart.\nChrg', field: 'Cartage', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
        }, isMandatory: false, isDefault: false, isSelected: true, align: "right"
    },
    {
        id: 16, header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'Hamali', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
        }, isMandatory: false, isDefault: false, isSelected: true, align: "right"
    },
    {
        id: 17, header: 'Oth.\nChrg', exportHead: 'Oth.\nChrg', field: 'OtherChg', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
        }, isMandatory: false, isDefault: false, isSelected: true, align: "right"
    },
    {
        id: 18, header: 'Bkg.\nGST', exportHead: 'Bkg.\nGST', field: 'ServiceTaxAmount', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
        }, isMandatory: false, isDefault: false, isSelected: true, align: "right"
    },
    {
        id: 19, header: 'Val.\nChrg', exportHead: 'Val.\nChrg', field: 'Valuation', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
        }, isMandatory: false, isDefault: false, isSelected: true, align: "right"
    },
    {
        id: 20, header: 'Net.\nAmt.', exportHead: 'Net.\nAmt.', field: 'NetAmount', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "right"
    },

]

export const LRWiseDetManageColumnsWithFormatLR = [
    {
        id: 1, header: 'Sr\nNo.', exportHead: 'Sr\nNo.', field: 'SN', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 40, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "left"
    },
    {
        id: 2, header: 'LR No-\nMan. LR No.', exportHead: 'LR No-\nMan. LR No.', field: 'LR', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "left"
    },
    {
        id: 21, header: 'Formatted LR No', exportHead: 'Formatted LR No', field: 'FormattedLRNO', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "left"
    },
    {
        id: 3, header: 'Chln No.\nBill No.', exportHead: 'Chln No.\nBill No.', field: 'ChBill', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "left"
    },
    {
        id: 4, header: 'Disp. Date\nDisp. Time', exportHead: 'Disp. Date\nDisp. Time', field: 'DispDT', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "left"
    },
    {
        id: 5, header: 'Rcvd. Date\nRcvd. Time', exportHead: 'Rcvd. Date\nRcvd. Time', field: 'RcvdDT', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "left"
    },
    {
        id: 6, header: 'Veh. No\nDrvr. No', exportHead: 'Veh. No\nDrvr. No', field: 'VD', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "left"
    },
    {
        id: 7, header: 'Src. Branch\nDest. Branch', exportHead: 'Src. Branch\nDest. Branch', field: 'SBDB', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "left"
    },
    {
        id: 8, header: 'Disp.City\nDisp.Br', exportHead: 'Disp.City\nDisp.Br', field: 'DispCityBr', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "left"
    },
    {
        id: 9, header: 'Sndr.\nDetails', exportHead: 'Sndr.\nDetails', field: 'SD', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: false, isDefault: false, isSelected: true, align: "left"
    },
    {
        id: 10, header: 'Rcvr.\nDetails', exportHead: 'Rcvr.\nDetails', field: 'RcvdD', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: false, isDefault: false, isSelected: true, align: "left"
    },
    {
        id: 11, header: 'Pymt.\nType.', exportHead: 'Pymt.\nType.', field: 'PaymentType', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "left"
    },
    {
        id: 12, header: 'Cons. Type', exportHead: 'Cons. Type', field: 'ItemType', xlCol: { dataType: 'string', dataFormatter: null, halign: "left" }, pdfColSx: {
            fontSize: 16, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: false, isDefault: false, isSelected: true, align: "left"
    },
    {
        id: 13, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'NOP', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "right"
    },
    {
        id: 14, header: 'Frt.\nChrg', exportHead: 'Frt.\nChrg', field: 'Freight', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
        }, isMandatory: false, isDefault: false, isSelected: true, align: "right"
    },
    {
        id: 15, header: 'Cart.\nChrg', exportHead: 'Cart.\nChrg', field: 'Cartage', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
        }, isMandatory: false, isDefault: false, isSelected: true, align: "right"
    },
    {
        id: 16, header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'Hamali', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
        }, isMandatory: false, isDefault: false, isSelected: true, align: "right"
    },
    {
        id: 17, header: 'Oth.\nChrg', exportHead: 'Oth.\nChrg', field: 'OtherChg', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
        }, isMandatory: false, isDefault: false, isSelected: true, align: "right"
    },
    {
        id: 18, header: 'Bkg.\nGST', exportHead: 'Bkg.\nGST', field: 'ServiceTaxAmount', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
        }, isMandatory: false, isDefault: false, isSelected: true, align: "right"
    },
    {
        id: 19, header: 'Val.\nChrg', exportHead: 'Val.\nChrg', field: 'Valuation', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
        }, isMandatory: false, isDefault: false, isSelected: true, align: "right"
    },
    {
        id: 20, header: 'Net.\nAmt.', exportHead: 'Net.\nAmt.', field: 'NetAmount', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "right"
    },

]
export const ownReceiveUpdatedColumn =(allowFormatLR,loginCountryId,UseToPayAsCOD)=>{
  const lrCols = [];
  if (allowFormatLR === 3) {
    lrCols.push({
      id: 1,
      header: "LR No.\nMan. LR No.",
      exportHead: "LR Number\nManual LR Number",
      field: "LRNO^^ManualLR",
      isSelected: true, isDefault: true, isMandatory: true,
      weight: 130,
      xlCol: { dataType: "string", dataFormatter: null },
      pdfColSx: { halign: "left", textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: "Roboto", valign: "top", minCellHeight: 36 },
      headerSx: { textAlign: "left" }, isSortIcon: true
    });
    lrCols.push({
      id: 2,
      header: "Formatted LR No",
      exportHead: "Formatted LR Number",
      field: "FormattedLRNO",
      isSelected: true, isDefault: true, isMandatory: false,
      weight: 100,
      xlCol: { dataType: "string", dataFormatter: null },
      pdfColSx: { halign: "left", textColor: [0, 0, 0], fontSize: 16, minCellWidth: 90, cellPadding: 6, font: "Roboto", valign: "top", minCellHeight: 36 },
      headerSx: { textAlign: "left" }, isSortIcon: true
    });
  }
  else if (allowFormatLR === 2) {
    lrCols.push({
      id: 1,
      header: "LR No.",
      exportHead: "LR Number",
      field: "LRNO",
      isSelected: true, isDefault: true, isMandatory: true,
      weight: 95,
      xlCol: { dataType: "string", dataFormatter: null },
      pdfColSx: { halign: "left", textColor: [0, 0, 0], minCellWidth: 80, cellPadding: 6, font: "Roboto" },
      headerSx: { textAlign: "left" }, isSortIcon: true
    });
    lrCols.push({
      id: 2,
      header: "Formatted LR No",
      exportHead: "Formatted LR Number",
      field: "FormattedLRNO",
      isSelected: true, isDefault: true, isMandatory: false,
      weight: 100,
      xlCol: { dataType: "string", dataFormatter: null },
      pdfColSx: { halign: "left", textColor: [0, 0, 0], minCellWidth: 90, cellPadding: 6, font: "Roboto" },
      headerSx: { textAlign: "left" }, isSortIcon: true
    });
  }
  else {
    lrCols.push({
      id: 1,
      header: "LR No.\nMan. LR No.",
      exportHead: "LR Number\nManual LR Number",
      field: "LRNO^^ManualLR",
      isSelected: true, isDefault: true, isMandatory: true,
      weight: 130,
      xlCol: { dataType: "string", dataFormatter: null },
      pdfColSx: { halign: "left", textColor: [0, 0, 0], minCellWidth: 120, cellPadding: 6, font: "Roboto" },
      headerSx: { textAlign: "left" }, isSortIcon: true
    });
  }
  return  [
    {
        id: 1, header: 'Sr\nNo.', exportHead: 'Sr\nNo.', field: 'SN', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 40, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "left", weight: 45, isSortIcon: false
    },
    ...lrCols,
    {
        id: 3, header: 'Chln No.\nBill No.', exportHead: 'Chln No.\nBill No.', field: 'ChallanNo^^PartyBillNo', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "left", weight: 110, isSortIcon: true
    },
    {
        id: 4, header: 'Disp. Date\nDisp. Time', exportHead: 'Disp. Date\nDisp. Time', field: 'DispatchDateTime', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "left", weight: 125, isSortIcon: true
    },
    {
        id: 5, header: 'Rcvd. Date\nRcvd. Time', exportHead: 'Rcvd. Date\nRcvd. Time', field: 'ReceiveDateTime', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "left", weight: 125, isSortIcon: true
    },
    {
        id: 6, header: 'Veh. No\nDrvr. No', exportHead: 'Veh. No\nDrvr. No', field: 'VehicleNo^^DriverContactNo', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 100, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "left", weight: 110, isSortIcon: true
    },
    {
        id: 7, header: 'Src. Branch\nDest. Branch', exportHead: 'Src. Branch\nDest. Branch', field: 'BookingBranch^^DestinationBranch', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "left", weight: 135, isSortIcon: true
    },
    {
        id: 8, header: 'Disp.City\nDisp.Br', exportHead: 'Disp.City\nDisp.Br', field: 'DispatchedCity^^DispatchedBranch', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "left", weight: 130, isSortIcon: true
    },
    {
        id: 9, header: 'Sndr.\nDetails', exportHead: 'Sndr.\nDetails', field: 'SenderName^^SenderMobileNo^^SenderGSTN^^SenderEmailID', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: false, isDefault: false, isSelected: true, align: "left", weight: 125, isSortIcon: true
    },
    {
        id: 10, header: 'Rcvr.\nDetails', exportHead: 'Rcvr.\nDetails', field: 'RecName^^RecMobileNo^^ReceiverGSTN^^ReceiverEmailID', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: false, isDefault: false, isSelected: true, align: "left", weight: 125, isSortIcon: true
    },
    {
        id: 11, header: 'Pymt.\nType.', exportHead: 'Pymt.\nType.', field: 'PaymentType', xlCol: { dataType: 'string', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "left", weight: 95, isSortIcon: true
    },
    {
        id: 12, header: 'Cons. Type', exportHead: 'Cons. Type', field: 'ItemType', xlCol: { dataType: 'string', dataFormatter: null, halign: "left" }, pdfColSx: {
            fontSize: 16, minCellWidth: 120, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'left'
        }, isMandatory: false, isDefault: false, isSelected: true, align: "left", weight: 90, isSortIcon: true
    },
    {
        id: 13, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'NOP', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "right", weight: 65, isSortIcon: true
    },
    {
        id: 14, header: 'Frt.\nChrg', exportHead: 'Frt.\nChrg', field: 'Freight', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
        }, isMandatory: false, isDefault: false, isSelected: true, align: "right", weight: 75, isSortIcon: true
    },
    {
        id: 15, header: 'Cart.\nChrg', exportHead: 'Cart.\nChrg', field: 'Cartage', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
        }, isMandatory: false, isDefault: false, isSelected: true, align: "right", weight: 75, isSortIcon: true
    },
    {
        id: 16, header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'Hamali', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
        }, isMandatory: false, isDefault: false, isSelected: true, align: "right", weight: 75, isSortIcon: true
    },
    {
        id: 17, header: 'Oth.\nChrg', exportHead: 'Oth.\nChrg', field: 'OtherChg', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
        }, isMandatory: false, isDefault: false, isSelected: true, align: "right", weight: 75, isSortIcon: true
    },
    ...(loginCountryId !== 2 ? [{
      id: 18,
      header: 'Bkg.\nGST',
      exportHead: 'Bkg.\nGST',
      field: 'ServiceTaxAmount',
      xlCol: { dataType: 'number', dataFormatter: null },
      pdfColSx: { fontSize: 16, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right' },
      isMandatory: false, isDefault: false, isSelected: true, align: "right", weight: 75, isSortIcon: true
    }] : []),
    {
      id: 19,
      header: UseToPayAsCOD === 1 ? 'Insu.\nChrg.' : 'Val.\nChrg.',
      exportHead: UseToPayAsCOD === 1 ? 'Insurance\nCharge' : 'Valuation\nCharge',
      field: 'Valuation',
      xlCol: { dataType: 'number', dataFormatter: null },
      pdfColSx: { fontSize: 16, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right' },
      isMandatory: false, isDefault: false, isSelected: true, align: "right", weight: 80, isSortIcon: true
    },
    {
        id: 20, header: 'Net.\nAmt.', exportHead: 'Net.\nAmt.', field: 'NetAmount', xlCol: { dataType: 'number', dataFormatter: null }, pdfColSx: {
            fontSize: 16, minCellWidth: 90, font: 'Roboto', textColor: [0, 0, 0], minCellHeight: 36, cellPadding: 3, halign: 'right'
        }, isMandatory: true, isDefault: true, isSelected: true, align: "right", weight: 85, isSortIcon: true
    },
]
}
// export const LRWiseDetManageColumnsForExcel = [
//     { halign: 'right', header: 'Sr\nNo.', field: 'SN' },
//     { halign: 'left', header: 'LR No.', field: "LR" },
//     { halign: 'left', header: 'Man. LR No.', field: "LR" },
//     { halign: 'left', header: 'Formatted LR No', field: "FormattedLRNO" },
//     { halign: 'left', header: 'Chln No.', field: 'ChBill' },
//     { halign: 'left', header: 'Bill No.', field: 'ChBill' },
//     { halign: 'left', header: 'Disp. Date', field: 'DispDT' },
//     { halign: 'left', header: 'Disp. Time', field: 'DispDT' },
//     { halign: 'left', header: 'Rcvd. Date', field: 'RcvdDT' },
//     { halign: 'left', header: 'Rcvd. Time', field: 'RcvdDT' },
//     { halign: 'left', header: 'Veh. No', field: 'VD' },
//     { halign: 'left', header: 'Drvr. No', field: 'VD' },
//     { halign: 'left', header: 'Src. Branch', field: 'SBDB' },
//     { halign: 'left', header: 'Dest. Branch', field: 'SBDB' },
//     { halign: 'left', header: 'Disp.City', field: 'DispCityBr' },
//     { halign: 'left', header: 'Disp.Br', field: 'DispCityBr' },
//     { halign: 'left', header: 'Sndr. Details', field: 'SD' },
//     { halign: 'left', header: 'Rcvr. Details', field: 'RcvdD' },
//     { halign: 'left', header: 'Pymt. Type.', field: 'PaymentType' },
//     { halign: 'left', header: 'Cons. Type', field: 'ItemType' },
//     { halign: 'right', header: 'Item Units', field: 'NOP' },
//     { halign: 'right', header: 'Frt. Chrg.', field: 'Freight' },
//     { halign: 'right', header: 'Cart. Chrg', field: 'Cartage' },
//     { halign: 'right', header: 'Ham. Chrg.', field: 'Hamali' },
//     { halign: 'right', header: 'Oth. Chrg', field: 'OtherChg' },
//     { halign: 'right', header: 'Bkg. GST', field: 'ServiceTaxAmount' },
//     { halign: 'right', header: 'Val. Chrg', field: 'Valuation' },
//     { halign: 'right', header: 'Net. Amt.', field: 'NetAmount' },
// ];

export const getLRWiseDetManageColumnsForExcel = (UseToPayAsCOD = 0, allowFormatLR = 0, loginCountryId = 1) => {
    let columns = [
        { halign: 'right', header: 'Serial Number', field: 'SN' },
        { halign: 'left', header: 'LR Number', field: "LR" },
        { halign: 'left', header: 'Manual LR Number', field: "LR" },
        { halign: 'left', header: 'Formatted LR Number', field: "FormattedLRNO" },
        { halign: 'left', header: 'Challan Number', field: 'ChBill' },
        { halign: 'left', header: 'Bill Number', field: 'ChBill' },
        { halign: 'left', header: 'Dispatch Date', field: 'DispDT' },
        { halign: 'left', header: 'Dispatch Time', field: 'DispDT' },
        { halign: 'left', header: 'Received Date', field: 'RcvdDT' },
        { halign: 'left', header: 'Received Time', field: 'RcvdDT' },
        { halign: 'left', header: 'Vehicle Number', field: 'VD' },
        { halign: 'left', header: 'Driver Number', field: 'VD' },
        { halign: 'left', header: 'Source Branch', field: 'SBDB' },
        { halign: 'left', header: 'Destination Branch', field: 'SBDB' },
        { halign: 'left', header: 'Dispatch City', field: 'DispCityBr' },
        { halign: 'left', header: 'Dispatch Branch', field: 'DispCityBr' },
        { halign: 'left', header: 'Sender Details', field: 'SD' },
        { halign: 'left', header: 'Receiver Details', field: 'RcvdD' },
        { halign: 'left', header: 'Payment Type', field: 'PaymentType' },
        { halign: 'left', header: 'Consignment Type', field: 'ItemType' },
        { halign: 'right', header: 'Item Units', field: 'NOP' },
        { halign: 'right', header: 'Freight Charge', field: 'Freight' },
        { halign: 'right', header: 'Cartage Charge', field: 'Cartage' },
        { halign: 'right', header: 'Hamali Charge', field: 'Hamali' },
        { halign: 'right', header: 'Other Charge', field: 'OtherChg' },
        { halign: 'right', header: 'Booking GST', field: 'ServiceTaxAmount' },
        { halign: 'right', header: 'Valuation Charge', field: 'Valuation' },
        { halign: 'right', header: 'Net Amount', field: 'NetAmount' },
    ];
    if (allowFormatLR !== 3) {
        columns = columns.filter(col => col.field !== 'FormattedLRNO');
    }
    if (loginCountryId === 2) {
        columns = columns.filter(col => col.field !== 'ServiceTaxAmount');
    }
    columns = columns.map(col => {
        if (col.field === 'Valuation') {
            return {
                ...col,
                header: UseToPayAsCOD === 1 ? 'Insurance\nCharge' : 'Valuation Charge',
            };
        }
        return col;
    });

    return columns;
};

export const paymentWiseColumns = [
  { headerName: 'SrNo.', exportHead: 'SrNo.', field: 'SN', weight: 70, xlCol: { dataType: 'number', dataFormatter: null, halign: "left" }, align: "left" , isSortIcon: false},
  { headerName: 'PaymentType', exportHead: 'PaymentType', field: 'PaymentType', weight: 150, xlCol: { dataType: 'string', dataFormatter: null, halign: "left" }, align: "left", isSortIcon: true },
  { headerName: 'Item Unit', exportHead: 'Item Unit', field: 'NOP', weight: 90, xlCol: { dataType: 'number', dataFormatter: null, halign: "right" }, align: "right", isSortIcon: true },
  { headerName: 'Freight Charge', exportHead: 'Freight Charge', field: 'Freight', weight: 100, xlCol: { dataType: 'number', dataFormatter: null, halign: "right" }, align: "right", isSortIcon: true },
  { headerName: 'Cartage Charge', exportHead: 'Cartage Charge', field: 'CartageAmt', weight: 110, xlCol: { dataType: 'number', dataFormatter: null, halign: "right" }, align: "right", isSortIcon: true },
  { headerName: 'Hamali Charge', exportHead: 'Hamali Charge', field: 'HamaliChgs', weight: 110, xlCol: { dataType: 'number', dataFormatter: null, halign: "right" }, align: "right", isSortIcon: true },
  { headerName: 'Other Charge', exportHead: 'Other Charge', field: 'OtherChgs', weight: 100, xlCol: { dataType: 'number', dataFormatter: null, halign: "right" }, align: "right", isSortIcon: true },
  { headerName: 'Booking GST', exportHead: 'Booking GST', field: 'ServiceTaxAmount', weight: 100, xlCol: { dataType: 'number', dataFormatter: null, halign: "right" }, align: "right" , isSortIcon: true},
  { headerName: 'Valuation Charge', exportHead: 'Valuation Charge', field: 'Valuation', weight: 110, xlCol: { dataType: 'number', dataFormatter: null, halign: "right" }, align: "right", isSortIcon: true },
  { headerName: 'Net Amount', exportHead: 'Net Amount', field: 'NetAmount', weight: 100, xlCol: { dataType: 'number', dataFormatter: null, halign: "right" }, align: "right", isSortIcon: true },
]
export const paymentWiseColumnsStyles = {
    0: { halign: 'right', cellWidth: 50, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    1: { halign: 'left', cellWidth: 150, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    2: { halign: 'right', fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    3: { halign: 'right', fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    4: { halign: 'right', fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    5: { halign: 'right', fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    6: { halign: 'right', fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    7: { halign: 'right', fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    8: { halign: 'right', fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    9: { halign: 'right', fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
}
export const summaryColumnsStyles = {
    0: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    1: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    2: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    3: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    4: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    5: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    6: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    7: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    8: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    9: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    10: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    11: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    12: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    13: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    14: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    15: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    16: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    17: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    18: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    19: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
}
export const detailColumnsStyles = {
    0: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    1: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    2: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    3: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    4: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    5: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    6: { halign: 'left', cellWidth: 150, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    // 6: { halign: 'left', cellWidth:100,minCellHeight:36,fontSize: 16, cellPadding:6,valign:"middle",fontStyle:"normal",font: 'Roboto',textColor: [0,0,0] },
    7: { halign: 'left', cellWidth: 150, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    8: { halign: 'left', cellWidth: 150, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    9: { halign: 'left', cellWidth: 150, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    10: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    11: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    12: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    13: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    14: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    15: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    16: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    17: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    18: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    19: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
}
const subHeading = {
    SN: "Sr\nNo.", VehicleNo: 'Vehicle\nNo.', DriverNameNo: 'Driver Name\nDriver No.', SrceDestBranch: 'Srce. Branch\nDest. Branch', DispCityBranch: 'Disp. City\nDisp. Branch',
    RecdCityBranch: 'Recd. City\nRecd. Branch', NOP: 'Item\nUnits', Freight: 'Frt\nChrg', Cartage: 'Cart\nChrg', Hamali: 'Ham\nChrg', OtherChg: 'Oth\nChrg', ServiceTaxAmount: 'Bkg\nGST',
    Valuation: 'Val\nChrg', paidAmt: 'Paid\nAmt.', ToPayCod: 'ToPay+\nCOD Amt.', FOCAmt: "FOC", OnAcc: 'OnAct\nAmt', SelfAmt: 'Self Bkg.\nAmt.', DDDVAmt: 'DDDV\nAmt.', NetAmount: "Net\nAmt.",
    isSubHeading: true
}

export const SummaryColumns = [
  { headerName: 'Sr\nNo.', exportHead: 'Sr\nNo.', field: 'SN', weight: 70, xlCol: { dataType: 'number', dataFormatter: null }, align: "left", isSortIcon: false },
  { headerName: 'Vehicle\nNo.', exportHead: 'Vehicle\nNo.', field: 'VehicleNo', weight: 110, xlCol: { dataType: 'string', dataFormatter: null }, align: "left" , isSortIcon: true},
  { headerName: 'Driver Name\nDriver No.', exportHead: 'Driver Name\nDriver No.', field: 'DriverNameNo', weight: 150, xlCol: { dataType: 'string', dataFormatter: null }, align: "left" , isSortIcon: true},
  { headerName: 'Srce. Branch\nDest. Branch', exportHead: 'Srce. Branch\nDest. Branch', field: 'SrceDestBranch', weight: 150, xlCol: { dataType: 'string', dataFormatter: null }, align: "left" , isSortIcon: true},
  { headerName: 'Disp. City\nDisp. Branch', exportHead: 'Disp. City\nDisp. Branch', field: 'DispCityBranch', weight: 150, xlCol: { dataType: 'string', dataFormatter: null }, align: "left", isSortIcon: true },
  { headerName: 'Recd. City\nRecd. Branch', exportHead: 'Recd. City\nRecd. Branch', field: 'RecdCityBranch', weight: 150, xlCol: { dataType: 'string', dataFormatter: null }, align: "left" , isSortIcon: true},
  { headerName: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'NOP', weight: 80, xlCol: { dataType: 'number', dataFormatter: null }, align: "right", isSortIcon: true },
  { headerName: 'Frt\nChrg', exportHead: 'Frt\nChrg', field: 'Freight', weight: 80, xlCol: { dataType: 'number', dataFormatter: null }, align: "right", isSortIcon: true },
  { headerName: 'Cart\nChrg', exportHead: 'Cart\nChrg', field: 'Cartage', weight: 80, xlCol: { dataType: 'number', dataFormatter: null }, align: "right", isSortIcon: true },
  { headerName: 'Ham\nChrg', exportHead: 'Ham\nChrg', field: 'Hamali', weight: 80, xlCol: { dataType: 'number', dataFormatter: null }, align: "right", isSortIcon: true },
  { headerName: 'Oth\nChrg', exportHead: 'Oth\nChrg', field: 'OtherChg', weight: 80, xlCol: { dataType: 'number', dataFormatter: null, halign: "right" }, align: "right" , isSortIcon: true},
  { headerName: 'Bkg\nGST', exportHead: 'Bkg\nGST', field: 'ServiceTaxAmount', weight: 80, xlCol: { dataType: 'number', dataFormatter: null }, align: "right", isSortIcon: true },
  { headerName: 'Val\nChrg', exportHead: 'Val\nChrg', field: 'Valuation', weight: 80, xlCol: { dataType: 'number', dataFormatter: null }, align: "right", isSortIcon: true },
  { headerName: 'Paid\nAmt.', exportHead: 'Paid\nAmt.', field: 'paidAmt', weight: 90, xlCol: { dataType: 'number', dataFormatter: null }, align: "right" , isSortIcon: true},
  { headerName: 'ToPay+\nCOD Amt.', exportHead: 'ToPay+\nCOD Amt.', field: 'ToPayCod', weight: 110, xlCol: { dataType: 'number', dataFormatter: null }, align: "right", isSortIcon: true },
  { headerName: 'FOC', exportHead: 'FOC', field: 'FOCAmt', weight: 70, xlCol: { dataType: 'number', dataFormatter: null }, align: "right", isSortIcon: true },
  { headerName: 'OnAct\nAmt', exportHead: 'OnAct\nAmt', field: 'OnAcc', weight: 90, xlCol: { dataType: 'number', dataFormatter: null }, align: "right", isSortIcon: true },
  { headerName: 'Self Bkg.\nAmt.', exportHead: 'Self Bkg.\nAmt.', field: 'SelfAmt', weight: 110, xlCol: { dataType: 'number', dataFormatter: null }, align: "right", isSortIcon: true },
  { headerName: 'DDDV\nAmt.', exportHead: 'DDDV\nAmt.', field: 'DDDVAmt', weight: 90, xlCol: { dataType: 'number', dataFormatter: null }, align: "right", isSortIcon: true },
  { headerName: 'Net\nAmt.', exportHead: 'Net\nAmt.', field: 'NetAmount', weight: 100, xlCol: { dataType: 'number', dataFormatter: null }, align: "right", isSortIcon: true },
]
export const pdfHeaderColumn1 = [
    { headerName: 'Company', exportHead: 'Company', field: 'company', xlCol: { dataType: 'number', dataFormatter: null }, align: "left" },
    { headerName: 'Source City', exportHead: 'Source City', field: 'selSourceCity', xlCol: { dataType: 'number', dataFormatter: null }, align: "left" },
    { headerName: 'Source Branch', exportHead: 'Source Branch', field: 'selSourceBranch', xlCol: { dataType: 'string', dataFormatter: null }, align: "left" },
    { headerName: 'Received City', exportHead: 'Received City', field: 'selReceivedCity', xlCol: { dataType: 'string', dataFormatter: null }, align: "right" },
    { headerName: 'Received Branch', exportHead: 'Received Branch', field: 'selReceivedBranch', xlCol: { dataType: 'string', dataFormatter: null }, align: "right" },
]
export const pdfHeaderColumn2 = [
    { headerName: 'Payment Type', exportHead: 'Payment Type', field: 'paymentType', xlCol: { dataType: 'string', dataFormatter: null }, align: "right" },
    { headerName: 'Booking Type', exportHead: 'Booking Type', field: 'bookingType', xlCol: { dataType: 'number', dataFormatter: null }, align: "left" },
    { headerName: 'Received Type', exportHead: 'Received Type', field: 'receiveType', xlCol: { dataType: 'string', dataFormatter: null }, align: "left" },
    { headerName: 'Report View', exportHead: 'Report View', field: 'reportView', xlCol: { dataType: 'string', dataFormatter: null }, align: "right" },
    { headerName: 'Report Options', exportHead: 'Report Options', field: 'reportOptions', xlCol: { dataType: 'string', dataFormatter: null }, align: "right" },
    { headerName: 'Auto Received Only ?', exportHead: 'Auto Received Only ?', field: 'showOnlyAutoRec', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
]
export const excelHeader1 = [{ col: 2, value: "Company" }, { col: 2, value: "From Received Date" }, { col: 2, value: "To Received Date" }, { col: 2, value: "Source City" },
{ col: 2, value: "Source Branch" }, { col: 2, value: "Received City" }, { col: 2, value: "Received Branch" },]

export const excelHeader2 = [{ col: 2, value: "Payment Type" }, { col: 2, value: "Booking Type" }, { col: 2, value: "Received Type" }, { col: 2, value: "Report View" }, { col: 2, value: "Report Options" }, { col: 2, value: "Auto Received Only ?" }, { col: 2, value: "" }]

export const excelHeader1Summry = [{ col: 3, value: "Company" }, { col: 3, value: "From Received Date" }, { col: 3, value: "To Received Date" }, { col: 3, value: "Source City" },
{ col: 3, value: "Source Branch" }, { col: 3, value: "Received City" }, { col: 2, value: "Received Branch" },]

export const excelHeader2Summary = [{ col: 3, value: "Payment Type" }, { col: 3, value: "Booking Type" }, { col: 3, value: "Received Type" }, { col: 3, value: "Report View" }, { col: 3, value: "Report Options" }, { col: 3, value: "Auto Received Only ?" }, { col: 2, value: "" }]
export const filterHeaderForLRWiseDetManageColumns = [
    { header: 'Company', field: "company" },
    { header: 'From Received Date', field: "toDate" },
    { header: 'To Received Date', field: "fromDate" },
    { header: 'Source City', field: "selSourceCity" },
    { header: 'Source Branch', field: "selSourceBranch" },
    { header: 'Received City', field: "selReceivedCity" },
    { header: 'Received Branch', field: "selReceivedBranch" },
    { header: 'Payment Type', field: "paymentType" },
    { header: 'Booking Type', field: "bookingType" },
    { header: 'Received Type', field: "receiveType" },
    { header: 'Report View', field: "reportView" },
    { header: 'Report Options', field: "reportOptions" },
    { header: 'Auto Received Only ?', field: "showOnlyAutoRec" },
    { header: '', field: "" },
]
export const filterHeaderForLRWiseDetManageColumns1 = [
    // { headerName: 'Company', dataKey: "company" },
    // { headerName: 'From Received Date', dataKey: "toDate"},
    // { headerName: 'To Received Date', dataKey: "fromDate"},
    // { headerName: 'Source City', dataKey: "selSourceCity"},
    // { headerName: 'Source Branch', dataKey: "selSourceBranch"},
    // { headerName: 'Received City', dataKey: "selReceivedCity"},
    // { headerName: 'Received Branch', dataKey: "selReceivedBranch"},
    { headerName: 'Payment Type', dataKey: "paymentType" },
    { headerName: 'Booking Type', dataKey: "bookingType" },
    { headerName: 'Received Type', dataKey: "receiveType" },
    { headerName: 'Report View', dataKey: "reportView" },
    { headerName: 'Report Options', dataKey: "reportOptions" },
    { headerName: 'Auto Received Only ?', dataKey: "showOnlyAutoRec" },
    { headerName: '', dataKey: "" },
]

export const updatePayTypeData = (arr1, arr2, selSourceCity, selReceivedCity,UseToPayAsCOD,loginCountryId) => {
    if (arr2?.length == 0) {
        arr2.push({ SN: 1, PaymentType: "", PaymentTypeID: 0, NOP: 0, Freight: 0, CartageAmt: 0, HamaliChgs: 0, OtherChgs: 0, ServiceTaxAmount: 0, Valuation: 0, NetAmount: 0, })
    }
    if (arr1?.length == 0) {
        arr1.push({ SN: 1, PaymentType: "", PaymentTypeID: 0, NOP: 0, Freight: 0, CartageAmt: 0, HamaliChgs: 0, OtherChgs: 0, ServiceTaxAmount: 0, Valuation: 0, NetAmount: 0, })
    }
    const heading = { SN: "Transaction: Received By CRS DeskApp", CartageAmt: `Source City: ${selSourceCity?.SourceCity}`, Valuation: `Received City: ${selReceivedCity?.ToCity}`, dataType:'subHeader', align:{SN:'left',CartageAmt:'left',Valuation:'right'},colSpan:{SN:4,CartageAmt:4,Valuation:2},backgroundColor:"#BFE1FF" }
    const subHeading = {
        SN: "SrNo.", PaymentType: "PaymentType", NOP: "Item Unit", Freight: "Freight Charge", CartageAmt: "Cartage Charge",
        HamaliChgs: "Hamali Charge", OtherChgs: "Other Charge", ServiceTaxAmount: "Booking GST", Valuation: loginCountryId===2?'Insurance Charge':"Valuation Charge", NetAmount: "Net Amount", FormattedLRNO: "Formatted LR No", dataType:'header', backgroundColor:"#f1f9ff"
    }
    let TotalNop = 0
    let TotalFreight = 0
    let TotalCartageAmt = 0
    let TotalHamaliChgs = 0
    let TotalOtherChgs = 0
    let TotalServiceTaxAmount = 0
    let TotalValuation = 0
    let TotalNetAmount = 0
    TotalNop = arr1?.map((item) => item?.NOP).reduce((partialSum, a) => partialSum + a, 0)
    TotalFreight = arr1?.map((item) => item?.Freight).reduce((partialSum, a) => partialSum + a, 0)
    TotalCartageAmt = arr1?.map((item) => item?.CartageAmt).reduce((partialSum, a) => partialSum + a, 0)
    TotalHamaliChgs = arr1?.map((item) => item?.HamaliChgs).reduce((partialSum, a) => partialSum + a, 0)
    TotalOtherChgs = arr1?.map((item) => item?.OtherChgs).reduce((partialSum, a) => partialSum + a, 0)
    TotalServiceTaxAmount = arr1?.map((item) => item?.ServiceTaxAmount).reduce((partialSum, a) => partialSum + a, 0)
    TotalValuation = arr1?.map((item) => item?.Valuation).reduce((partialSum, a) => partialSum + a, 0)
    TotalNetAmount = arr1?.map((item) => item?.NetAmount).reduce((partialSum, a) => partialSum + a, 0)
    arr1.unshift(subHeading)
    arr1.unshift(heading)
    arr1.push({
        SN: "Total: Received By CRS DeskApp", NOP: TotalNop, Freight: TotalFreight.toFixed(2), CartageAmt: TotalCartageAmt.toFixed(2), HamaliChgs: TotalHamaliChgs.toFixed(2),
        OtherChgs: TotalOtherChgs.toFixed(2), ServiceTaxAmount: TotalServiceTaxAmount.toFixed(2), Valuation: TotalValuation.toFixed(2), NetAmount: TotalNetAmount.toFixed(2), isTotal: true, dataType:'total', colSpan:{SN:2},align:{SN:'left'}
    })
    const arr1Total = {
        NOP: TotalNop, Freight: TotalFreight, CartageAmt: TotalCartageAmt, HamaliChgs: TotalHamaliChgs,
        OtherChgs: TotalOtherChgs, ServiceTaxAmount: TotalServiceTaxAmount, Valuation: TotalValuation, NetAmount: TotalNetAmount, isTotal: true, dataType:'total'
    }
    TotalNop = 0
    TotalFreight = 0
    TotalCartageAmt = 0
    TotalHamaliChgs = 0
    TotalOtherChgs = 0
    TotalServiceTaxAmount = 0
    TotalValuation = 0
    TotalNetAmount = 0

    TotalNop = arr2?.map((item) => item?.NOP).reduce((partialSum, a) => partialSum + a, 0)
    TotalFreight = arr2?.map((item) => item?.Freight).reduce((partialSum, a) => partialSum + a, 0)
    TotalCartageAmt = arr2?.map((item) => item?.CartageAmt).reduce((partialSum, a) => partialSum + a, 0)
    TotalHamaliChgs = arr2?.map((item) => item?.HamaliChgs).reduce((partialSum, a) => partialSum + a, 0)
    TotalOtherChgs = arr2?.map((item) => item?.OtherChgs).reduce((partialSum, a) => partialSum + a, 0)
    TotalServiceTaxAmount = arr2?.map((item) => item?.ServiceTaxAmount).reduce((partialSum, a) => partialSum + a, 0)
    TotalValuation = arr2?.map((item) => item?.Valuation).reduce((partialSum, a) => partialSum + a, 0)
    TotalNetAmount = arr2?.map((item) => item?.NetAmount).reduce((partialSum, a) => partialSum + a, 0)
    arr2.unshift({
        SN: "SrNo.", PaymentType: "PaymentType", NOP: "Item Unit", Freight: "Freight Charge", CartageAmt: "Cartage Charge",
        HamaliChgs: "Hamali Charge", OtherChgs: "Other Charge", ServiceTaxAmount: "Booking GST", Valuation: loginCountryId===2?'Insurance Charge':"Valuation Charge", NetAmount: "Net Amount",  dataType:'header', backgroundColor:"#f1f9ff"
    })
    arr2.unshift({ SN: "Transaction: Received By Maven Application", CartageAmt: `Source City: ${selSourceCity?.SourceCity}`, Valuation: `Received City: ${selReceivedCity?.ToCity}`,  dataType:'subHeader', align:{SN:'left',CartageAmt:'left',Valuation:'right'},colSpan:{SN:4,CartageAmt:4,Valuation:2}, backgroundColor:"#BFE1FF"})
    arr2.push({
        SN: "Total: Received By Maven Application", NOP: TotalNop, Freight: TotalFreight.toFixed(2), CartageAmt: TotalCartageAmt.toFixed(2), HamaliChgs: TotalHamaliChgs.toFixed(2),
        OtherChgs: TotalOtherChgs.toFixed(2), ServiceTaxAmount: TotalServiceTaxAmount.toFixed(2), Valuation: TotalValuation.toFixed(2), NetAmount: TotalNetAmount.toFixed(2), isTotal: true, dataType:'total', colSpan:{SN:2},align:{SN:'left'}
    })
    const data = [...arr1, ...arr2]
    data.push({
        SN: "Total: Received By CRS Desk APP & Maven Application", NOP: (TotalNop + arr1Total.NOP), Freight: (TotalFreight + arr1Total.Freight).toFixed(2), CartageAmt: (TotalCartageAmt + arr1Total.CartageAmt).toFixed(2), HamaliChgs: (TotalHamaliChgs + arr1Total.HamaliChgs).toFixed(2),
        OtherChgs: (TotalOtherChgs + arr1Total.OtherChgs).toFixed(2), ServiceTaxAmount: (TotalServiceTaxAmount + arr1Total.ServiceTaxAmount).toFixed(2), Valuation: (TotalValuation + arr1Total.Valuation).toFixed(2), NetAmount: (TotalNetAmount + arr1Total.NetAmount).toFixed(2), isTotal: true, dataType:'total',colSpan:{SN:2},align:{SN:'left'}
    })
    return data
}
const sum = (arr, key) =>
  arr.reduce((t, i) => t + (+i?.[key] || 0), 0);

const formatDateTime = (value = "") => {
  const [d, t] = value.split(" ");
  return `${d || ""}\n${t || ""}`;
};
const buildColSpanAndAlign = (headers) => {
  const lengths = divideInNIntegers(headers.length, 3);
  let index = 0;
  const pickedHeaders = [];
  lengths.forEach((span) => {
    pickedHeaders.push(headers[index]?.field);
    index += span;
  });
  return {
    pickedHeaders,
    colSpan: Object.fromEntries(
      pickedHeaders.map((key, i) => [key, lengths[i] || 1])
    ),
    align: {
      [pickedHeaders[0]]: "left",
      [pickedHeaders[1]]: "center",
      [pickedHeaders[2]]: "right",
    }
  };
};
const buildTableHeaderRow = (headers) => {
  const row = { dataType: "header", isTableHeader: true };
  headers.forEach(h => {
    row[h.field] = h.header || h.exportHead || h.label || "";
  });
  return row;
};

const pushTotalRow = (arr, label, headers) => {
  const totals = {
    NOP: sum(arr, "NOP"),
    Freight: sum(arr, "Freight"),
    Cartage: sum(arr, "Cartage"),
    Hamali: sum(arr, "Hamali"),
    OtherChg: sum(arr, "OtherChg"),
    ServiceTaxAmount: sum(arr, "ServiceTaxAmount"),
    Valuation: sum(arr, "Valuation"),
    NetAmount: sum(arr, "NetAmount"),
  };

  const qtyIndex = headers.findIndex(h => h.field === "NOP");
  const colSpanCount = qtyIndex > 0 ? qtyIndex : 1;
  const firstHeader = headers[0]?.field;

  arr.push({
    SN: label,
    ...Object.fromEntries(
      Object.entries(totals).map(([k, v]) => [k, v.toFixed(2)])
    ),
    dataType: "total",
    isTotal: true,
    colSpan: { [firstHeader]: colSpanCount },
    align: { [firstHeader]: "right" }
  });

  return totals;
};
export const updateDetailData1 = (
  array,
  headerData,
  headers
) => {
  const { pickedHeaders, colSpan, align } = buildColSpanAndAlign(headers);
  const tableHeaderRow = buildTableHeaderRow(headers);

  const data = array.map((item) => ({
    ...item,
    "LRNO^^ManualLR": `${item.LRNO}\n${item.ManualLR}`,
    "ChallanNo^^PartyBillNo": `${item.ChallanNo}\n${item.PartyBillNo}`,
    DispatchDateTime: formatDateTime(item.DispatchDateTime),
    ReceiveDateTime: formatDateTime(item.ReceiveDateTime),
    "VehicleNo^^DriverContactNo": `${item.VehicleNo}\n${item.DriverContactNo}`,
    "BookingBranch^^DestinationBranch": `${item.BookingBranch}\n${item.DestinationBranch}`,
    "SenderName^^SenderMobileNo^^SenderGSTN^^SenderEmailID":
      `${item.SenderName}\n${item.SenderMobileNo}\n${item.SenderGSTN}\n${item.SenderEmailID}`,
    "RecName^^RecMobileNo^^ReceiverGSTN^^ReceiverEmailID":
      `${item.RecName}\n${item.RecMobileNo}\n${item.ReceiverGSTN}\n${item.ReceiverEmailID}`,
    "DispatchedCity^^DispatchedBranch":
      `${item.DispatchedCity}\n${item.DispatchedBranch}`,
  }));

  let crsArr = data.filter(i => i.IsApp === 0).map((item, index) => ({
    ...item,
    SN: index + 1,
  }));
  let appArr = data.filter(i => i.IsApp === 1).map((item, index) => ({
    ...item,
    SN: index + 1,
  }));

  if (!crsArr.length) crsArr = [{ SN: 1 }];
  if (!appArr.length) appArr = [{ SN: 1 }];

  /* -------- CRS SECTION -------- */
  crsArr.unshift(
    {
      [pickedHeaders[0]]: "Transaction: Received By CRS DeskApp",
      [pickedHeaders[1]]: `Source City: ${headerData?.selSourceCity}`,
      [pickedHeaders[2]]: `Received City: ${headerData?.selReceivedCity}`,
      colSpan,
      align,
      dataType: "subHeader",
      isHeading: true,
      totalSubKey:3
    },
    // tableHeaderRow
  );

  /* -------- MAVEN SECTION -------- */
  appArr.unshift(
    tableHeaderRow,
    {
      [pickedHeaders[0]]: "Transaction: Received By Maven Application",
      [pickedHeaders[1]]: `Source City: ${headerData?.selSourceCity}`,
      [pickedHeaders[2]]: `Received City: ${headerData?.selReceivedCity}`,
      colSpan,
      align,
      dataType: "subHeader",
      isHeading: true,
      totalSubKey:3
    }
  );

  const crsTotals = pushTotalRow(
    crsArr,
    "Total: Received By CRS DeskApp",
    headers
  );

  const appTotals = pushTotalRow(
    appArr,
    "Total: Received By Maven Application",
    headers
  );

  const qtyIndex = headers.findIndex(h => h.field === "NOP");
  const colSpanCount = qtyIndex > 0 ? qtyIndex : 1;
  const firstHeader = headers[0]?.field;

  return [
    ...crsArr,
    ...appArr,
    {
      SN: "Total: Received By CRS DeskApp & Maven Application",
      NOP: (crsTotals.NOP + appTotals.NOP).toFixed(2),
      Freight: (crsTotals.Freight + appTotals.Freight).toFixed(2),
      Cartage: (crsTotals.Cartage + appTotals.Cartage).toFixed(2),
      Hamali: (crsTotals.Hamali + appTotals.Hamali).toFixed(2),
      OtherChg: (crsTotals.OtherChg + appTotals.OtherChg).toFixed(2),
      ServiceTaxAmount: (
        crsTotals.ServiceTaxAmount + appTotals.ServiceTaxAmount
      ).toFixed(2),
      Valuation: (crsTotals.Valuation + appTotals.Valuation).toFixed(2),
      NetAmount: (crsTotals.NetAmount + appTotals.NetAmount).toFixed(2),
      dataType: "total",
      isTotal: true,
      colSpan: { [firstHeader]: colSpanCount },
      align: { [firstHeader]: "right" }
    }
  ];
};
export const updateDetailData = (
  array,
  headerData,
  headers
) => {
  const { pickedHeaders, colSpan, align } = buildColSpanAndAlign(headers);
  const tableHeaderRow = buildTableHeaderRow(headers);

  const data = array.map((item, i) => ({
    ...item,
    SN: i + 1,
    "LRNO^^ManualLR": `${item.LRNO}\n${item.ManualLR}`,
    "ChallanNo^^PartyBillNo": `${item.ChallanNo}\n${item.PartyBillNo}`,
    DispatchDateTime: formatDateTime(item.DispatchDateTime),
    ReceiveDateTime: formatDateTime(item.ReceiveDateTime),
    "VehicleNo^^DriverContactNo": `${item.VehicleNo}\n${item.DriverContactNo}`,
    "BookingBranch^^DestinationBranch": `${item.BookingBranch}\n${item.DestinationBranch}`,
    "SenderName^^SenderMobileNo^^SenderGSTN^^SenderEmailID":
      `${item.SenderName}\n${item.SenderMobileNo}\n${item.SenderGSTN}\n${item.SenderEmailID}`,
    "RecName^^RecMobileNo^^ReceiverGSTN^^ReceiverEmailID":
      `${item.RecName}\n${item.RecMobileNo}\n${item.ReceiverGSTN}\n${item.ReceiverEmailID}`,
    "DispatchedCity^^DispatchedBranch":
      `${item.DispatchedCity}\n${item.DispatchedBranch}`,
  }));

  let crsArr = data.filter(i => i.IsApp === 0);
  let appArr = data.filter(i => i.IsApp === 1);

  if (!crsArr.length) crsArr = [{ SN: 1 }];
  if (!appArr.length) appArr = [{ SN: 1 }];

  /* -------- CRS SECTION -------- */
  crsArr.unshift(
    {
      [pickedHeaders[0]]: "Transaction: Received By CRS DeskApp",
      [pickedHeaders[1]]: `Source City: ${headerData?.selSourceCity}`,
      [pickedHeaders[2]]: `Received City: ${headerData?.selReceivedCity}`,
      colSpan,
      align,
      dataType: "subHeader",
      isHeading: true
    },
    tableHeaderRow
  );

  /* -------- MAVEN SECTION -------- */
  appArr.unshift(
    {
      [pickedHeaders[0]]: "Transaction: Received By Maven Application",
      [pickedHeaders[1]]: `Source City: ${headerData?.selSourceCity}`,
      [pickedHeaders[2]]: `Received City: ${headerData?.selReceivedCity}`,
      colSpan,
      align,
      dataType: "subHeader",
      isHeading: true
    },
    tableHeaderRow
  );

  const crsTotals = pushTotalRow(
    crsArr,
    "Total: Received By CRS DeskApp",
    headers
  );

  const appTotals = pushTotalRow(
    appArr,
    "Total: Received By Maven Application",
    headers
  );

  const qtyIndex = headers.findIndex(h => h.field === "NOP");
  const colSpanCount = qtyIndex > 0 ? qtyIndex : 1;
  const firstHeader = headers[0]?.field;

  return [
    ...crsArr,
    ...appArr,
    {
      SN: "Total: Received By CRS DeskApp & Maven Application",
      NOP: (crsTotals.NOP + appTotals.NOP).toFixed(2),
      Freight: (crsTotals.Freight + appTotals.Freight).toFixed(2),
      Cartage: (crsTotals.Cartage + appTotals.Cartage).toFixed(2),
      Hamali: (crsTotals.Hamali + appTotals.Hamali).toFixed(2),
      OtherChg: (crsTotals.OtherChg + appTotals.OtherChg).toFixed(2),
      ServiceTaxAmount: (
        crsTotals.ServiceTaxAmount + appTotals.ServiceTaxAmount
      ).toFixed(2),
      Valuation: (crsTotals.Valuation + appTotals.Valuation).toFixed(2),
      NetAmount: (crsTotals.NetAmount + appTotals.NetAmount).toFixed(2),
      dataType: "total",
      isTotal: true,
      colSpan: { [firstHeader]: colSpanCount },
      align: { [firstHeader]: "right" }
    }
  ];
};
export const updateDetailDataForExcel = (array, headerData,UseToPayAsCOD,loginCountryId) => {
    const data = []
    array.forEach((item, i) => {
        data.push({
            ...item,
            SD: `${item.SenderName}\n${item.SenderMobileNo}\n${item.SenderGSTN}\n${item.SenderEmailID}`,
            RcvdD: `${item.RecName}\n${item.RecMobileNo}\n${item.ReceiverGSTN}\n${item.ReceiverEmailID}`,
        })
    })
    const subHeading = {
        SN: "Serial Number", LRNO: "LR Number ", ManualLR: "Manual LR Number", ChallanNo: "Challan Number", PartyBillNo: "Bill Number", DispatchDateTime: "Dispatch Date & Time", DispatchDateTime: "Dispatch Date & Time", ReceiveDateTime: "Received Date", ReceiveDateTime: "Received Time",
        VehicleNoD: "Vehicle Number", DriverContactNo: "Driver Number", BookingBranch: "Source Branch", DestinationBranch: "Destination Branch", DispatchedCity: "Dispatch City", DispatchedBranch: "Dispatch Branch", SD: "Sender\nDetails", RcvdD: "Receiver\nDetails", PaymentType: "Payment\nType.",
        ItemType: "Consignment\nType", NOP: "Item\nUnits", Freight: "Freight\nCharge", Cartage: "Cartage\nCharge", Hamali: "Hamali\nCharge", OtherChg: "Other\nCharge", ServiceTaxAmount: "Booking\nGST", Valuation: loginCountryId===2?'Insurance\nCharge':"Valuation\nCharge", NetAmount: "Net\nAmount",
        FormattedLRNO: "Formatted LR Number",
        isSubHeading: true
    }
    let arr1 = []
    let arr2 = []
    data?.map((val) => {
        if (val.IsApp == 0) {
            arr1.push(val)
        } else {
            arr2.push(val)
        }
    })
    arr1 = arr1?.map((val, i) => ({ ...val, SN: i + 1 }))
    arr2 = arr2?.map((val, i) => ({ ...val, SN: i + 1 }))
    if (arr2?.length == 0) {
        arr2.push({ SN: 1, ConsType: "", LR: "", chBill: "", DispDt: "", RcvdDT: "", VD: "", SBDB: "", SD: "", RcvdD: "", PaymentType: "", PaymentTypeInt: 0, NOP: 0, Freight: 0, Cartage: 0, Hamali: 0, OtherChg: 0, ServiceTaxAmount: 0, Valuation: 0, NetAmount: 0, })
    }
    if (arr1?.length == 0) {
        arr1.push({ SN: 1, ConsType: "", LR: "", chBill: "", DispDt: "", RcvdDT: "", VD: "", SBDB: "", SD: "", RcvdD: "", PaymentType: "", PaymentTypeInt: 0, NOP: 0, Freight: 0, Cartage: 0, Hamali: 0, OtherChg: 0, ServiceTaxAmount: 0, Valuation: 0, NetAmount: 0, })
    }
    let TotalNop = 0
    let TotalFreight = 0
    let TotalCartageAmt = 0
    let TotalHamaliChgs = 0
    let TotalOtherChgs = 0
    let TotalServiceTaxAmount = 0
    let TotalValuation = 0
    let TotalNetAmount = 0
    TotalNop = arr1?.map((item) => item?.NOP).reduce((partialSum, a) => partialSum + a, 0)
    TotalFreight = arr1?.map((item) => item?.Freight).reduce((partialSum, a) => partialSum + a, 0)
    TotalCartageAmt = arr1?.map((item) => item?.Cartage).reduce((partialSum, a) => partialSum + a, 0)
    TotalHamaliChgs = arr1?.map((item) => item?.Hamali).reduce((partialSum, a) => partialSum + a, 0)
    TotalOtherChgs = arr1?.map((item) => item?.OtherChg).reduce((partialSum, a) => partialSum + a, 0)
    TotalServiceTaxAmount = arr1?.map((item) => item?.ServiceTaxAmount).reduce((partialSum, a) => partialSum + a, 0)
    TotalValuation = arr1?.map((item) => item?.Valuation).reduce((partialSum, a) => partialSum + a, 0)
    TotalNetAmount = arr1?.map((item) => item?.NetAmount).reduce((partialSum, a) => partialSum + a, 0)
    arr1.push({
        SN: "Total: Recived By CRS DeskApp", NOP: TotalNop, Freight: TotalFreight.toFixed(2), Cartage: TotalCartageAmt.toFixed(2), Hamali: TotalHamaliChgs.toFixed(2),
        OtherChg: TotalOtherChgs.toFixed(2), ServiceTaxAmount: TotalServiceTaxAmount.toFixed(2), Valuation: TotalValuation.toFixed(2), NetAmount: TotalNetAmount.toFixed(2), isTotal: true
    })
    const arr1Total = {
        NOP: TotalNop, Freight: TotalFreight, Cartage: TotalCartageAmt, Hamali: TotalHamaliChgs, OtherChg: TotalOtherChgs, ServiceTaxAmount: TotalServiceTaxAmount,
        Valuation: TotalValuation, NetAmount: TotalNetAmount,
    }
    TotalNop = 0
    TotalFreight = 0
    TotalCartageAmt = 0
    TotalHamaliChgs = 0
    TotalOtherChgs = 0
    TotalServiceTaxAmount = 0
    TotalValuation = 0
    TotalNetAmount = 0

    TotalNop = arr2?.map((item) => item?.NOP).reduce((partialSum, a) => partialSum + a, 0)
    TotalFreight = arr2?.map((item) => item?.Freight).reduce((partialSum, a) => partialSum + a, 0)
    TotalCartageAmt = arr2?.map((item) => item?.Cartage).reduce((partialSum, a) => partialSum + a, 0)
    TotalHamaliChgs = arr2?.map((item) => item?.Hamali).reduce((partialSum, a) => partialSum + a, 0)
    TotalOtherChgs = arr2?.map((item) => item?.OtherChg).reduce((partialSum, a) => partialSum + a, 0)
    TotalServiceTaxAmount = arr2?.map((item) => item?.ServiceTaxAmount).reduce((partialSum, a) => partialSum + a, 0)
    TotalValuation = arr2?.map((item) => item?.Valuation).reduce((partialSum, a) => partialSum + a, 0)
    TotalNetAmount = arr2?.map((item) => item?.NetAmount).reduce((partialSum, a) => partialSum + a, 0)
    arr2.push({
        SN: "Total: Received By Maven Application", NOP: TotalNop, Freight: TotalFreight.toFixed(2), Cartage: TotalCartageAmt.toFixed(2), Hamali: TotalHamaliChgs.toFixed(2),
        OtherChg: TotalOtherChgs.toFixed(2), ServiceTaxAmount: TotalServiceTaxAmount.toFixed(2), Valuation: TotalValuation.toFixed(2), NetAmount: TotalNetAmount.toFixed(2), isTotal: true
    })
    arr1.unshift(subHeading)
    arr2.unshift(subHeading)
    arr1.unshift({ SN: "Transaction: Received By CRS DeskApp", SBDB: `Source City: ${headerData.selSourceCity}`, PaymentType: `Received City: ${headerData?.selReceivedCity}`, isHeading: true })
    arr2.unshift({ SN: "Transaction: Received By Maven Application", SBDB: `Source City: ${headerData.selSourceCity}`, PaymentType: `Received City: ${headerData?.selReceivedCity}`, isHeading: true })
    const updateData = [...arr1, ...arr2]
    updateData.push({
        SN: "Total: Received By CRS Desk APP & Maven Application", NOP: (TotalNop + arr1Total.NOP), Freight: (TotalFreight + arr1Total.Freight).toFixed(2), Cartage: (TotalCartageAmt + arr1Total.Cartage).toFixed(2), Hamali: (TotalHamaliChgs + arr1Total.Hamali).toFixed(2),
        OtherChg: (TotalOtherChgs + arr1Total.OtherChg).toFixed(2), ServiceTaxAmount: (TotalServiceTaxAmount + arr1Total.ServiceTaxAmount).toFixed(2), Valuation: (TotalValuation + arr1Total.Valuation).toFixed(2), NetAmount: (TotalNetAmount + arr1Total.NetAmount).toFixed(2), isTotal: true
    })
    return updateData
}
export const updateSummaryData = (array, headerData,UseToPayAsCOD,loginCountryId) => {
    const data = []
    array.forEach((item, i) => {
        data.push({
            ...item,
            dataType:'entry',
            DriverNameNo: `${item.DriverConductorName}\n${item.DriverContactNo}`,
            SrceDestBranch: `${item.BookingBranch}\n${item.DestinationBranch}`,
            DispCityBranch: `${item.DispatchedCity}\n${item.DispatchedBranch}`,
            RecdCityBranch: `${item.ReceivedCity}\n${item.ReceivedBranch}`,
            paidAmt: item.PaidAmt + item.PaidManAmt,
            ToPayCod: item.ToPayAmt + item.TopayManAmt + item.CODAmt,
            OnAcc: item.OnAccountAmt + item.OnAccountManAmt,
        })
    })
    let arr1 = []
    arr1 = data?.map((val, i) => ({ ...val, SN: i + 1 }))
    let TotalNop = 0
    let TotalFreight = 0
    let TotalCartageAmt = 0
    let TotalHamaliChgs = 0
    let TotalOtherChgs = 0
    let TotalServiceTaxAmount = 0
    let TotalValuation = 0
    let TotalpaidAmt = 0
    let TotalToPayCod = 0
    let TotalFOCAmt = 0
    let TotalOnAcc = 0
    let TotalSelfAmt = 0
    let TotalDDDVAmt = 0
    let TotalNetAmount = 0

    TotalNop = arr1?.map((item) => item?.NOP).reduce((partialSum, a) => partialSum + a, 0)
    TotalFreight = arr1?.map((item) => item?.Freight).reduce((partialSum, a) => partialSum + a, 0)
    TotalCartageAmt = arr1?.map((item) => item?.Cartage).reduce((partialSum, a) => partialSum + a, 0)
    TotalHamaliChgs = arr1?.map((item) => item?.Hamali).reduce((partialSum, a) => partialSum + a, 0)
    TotalOtherChgs = arr1?.map((item) => item?.OtherChg).reduce((partialSum, a) => partialSum + a, 0)
    TotalServiceTaxAmount = arr1?.map((item) => item?.ServiceTaxAmount).reduce((partialSum, a) => partialSum + a, 0)
    TotalValuation = arr1?.map((item) => item?.Valuation).reduce((partialSum, a) => partialSum + a, 0)
    TotalpaidAmt = arr1?.map((item) => item?.paidAmt).reduce((partialSum, a) => partialSum + a, 0)
    TotalToPayCod = arr1?.map((item) => item?.ToPayCod).reduce((partialSum, a) => partialSum + a, 0)
    TotalFOCAmt = arr1?.map((item) => item?.FOCAmt).reduce((partialSum, a) => partialSum + a, 0)
    TotalOnAcc = arr1?.map((item) => item?.OnAcc).reduce((partialSum, a) => partialSum + a, 0)
    TotalSelfAmt = arr1?.map((item) => item?.SelfAmt).reduce((partialSum, a) => partialSum + a, 0)
    TotalDDDVAmt = arr1?.map((item) => item?.DDDVAmt).reduce((partialSum, a) => partialSum + a, 0)
    TotalValuation = arr1?.map((item) => item?.Valuation).reduce((partialSum, a) => partialSum + a, 0)
    TotalNetAmount = arr1?.map((item) => item?.NetAmount).reduce((partialSum, a) => partialSum + a, 0)
    const heading = { SN: `Received Branch: ${headerData?.selReceivedBranch}`, NOP: `Source City: ${headerData?.selSourceCity}`, paidAmt: `Received City: ${headerData?.selReceivedCity}`,  dataType:'subHeader', align:{SN:'left',NOP:'center',paidAmt:'right'},colSpan:{SN:6,NOP:7,paidAmt:7} }
    const subHeading = {
        SN: "Sr\nNo.", VehicleNo: 'Vehicle\nNo.', DriverNameNo: 'Driver Name\nDriver No.', SrceDestBranch: 'Srce. Branch\nDest. Branch', DispCityBranch: 'Disp. City\nDisp. Branch',
        RecdCityBranch: 'Recd. City\nRecd. Branch', NOP: 'Item\nUnits', Freight: 'Frt\nChrg', Cartage: 'Cart\nChrg', Hamali: 'Ham\nChrg', OtherChg: 'Oth\nChrg', ServiceTaxAmount: 'Bkg\nGST',
        Valuation:  loginCountryId===2?'Insu.\nChrg':'Val\nChrg', paidAmt: 'Paid\nAmt.', ToPayCod: UseToPayAsCOD===1?'COD Amt.':'ToPay+\nCOD Amt.', FOCAmt: "FOC", OnAcc: 'OnAct\nAmt', SelfAmt: 'Self Bkg.\nAmt.', DDDVAmt: 'DDDV\nAmt.', NetAmount: "Net\nAmt.", dataType:'header', backgroundColor:"#f1f9ff", position:'sticky',
        isSubHeading: true
    }
    // arr1.unshift(subHeading)
    arr1.unshift(heading)
    arr1.push({
        SN: `Total: Received Branch: ${headerData?.selReceivedBranch}`, NOP: TotalNop, Freight: TotalFreight.toFixed(2), Cartage: TotalCartageAmt.toFixed(2), Hamali: TotalHamaliChgs.toFixed(2), OtherChg: TotalOtherChgs.toFixed(2), ServiceTaxAmount: TotalServiceTaxAmount.toFixed(2),
        Valuation: TotalValuation.toFixed(2), paidAmt: TotalpaidAmt.toFixed(2), ToPayCod: TotalToPayCod.toFixed(2), FOCAmt: TotalFOCAmt.toFixed(2), OnAcc: TotalOnAcc.toFixed(2), SelfAmt: TotalSelfAmt.toFixed(2), DDDVAmt: TotalDDDVAmt.toFixed(2), NetAmount: TotalNetAmount.toFixed(2),
        isTotal: true, dataType:'total', colSpan:{SN:6}, align:{SN:'right'}
    })
    return arr1
}
export const updateSummaryDataForExcel = (array, headerData,UseToPayAsCOD,loginCountryId) => {

    let arr1 = []
    arr1 = array?.map((val, i) => ({ ...val, SN: i + 1 }))
    let TotalNop = 0
    let TotalFreight = 0
    let TotalCartageAmt = 0
    let TotalHamaliChgs = 0
    let TotalOtherChgs = 0
    let TotalServiceTaxAmount = 0
    let TotalValuation = 0
    let TotalpaidAmt = 0
    let TotalToPayCod = 0
    let TotalFOCAmt = 0
    let TotalOnAcc = 0
    let TotalSelfAmt = 0
    let TotalDDDVAmt = 0
    let TotalNetAmount = 0

    TotalNop = arr1?.map((item) => item?.NOP).reduce((partialSum, a) => partialSum + a, 0)
    TotalFreight = arr1?.map((item) => item?.Freight).reduce((partialSum, a) => partialSum + a, 0)
    TotalCartageAmt = arr1?.map((item) => item?.Cartage).reduce((partialSum, a) => partialSum + a, 0)
    TotalHamaliChgs = arr1?.map((item) => item?.Hamali).reduce((partialSum, a) => partialSum + a, 0)
    TotalOtherChgs = arr1?.map((item) => item?.OtherChg).reduce((partialSum, a) => partialSum + a, 0)
    TotalServiceTaxAmount = arr1?.map((item) => item?.ServiceTaxAmount).reduce((partialSum, a) => partialSum + a, 0)
    TotalValuation = arr1?.map((item) => item?.Valuation).reduce((partialSum, a) => partialSum + a, 0)
    TotalpaidAmt = arr1?.map((item) => item?.paidAmt).reduce((partialSum, a) => partialSum + a, 0)
    TotalToPayCod = arr1?.map((item) => item?.ToPayCod).reduce((partialSum, a) => partialSum + a, 0)
    TotalFOCAmt = arr1?.map((item) => item?.FOCAmt).reduce((partialSum, a) => partialSum + a, 0)
    TotalOnAcc = arr1?.map((item) => item?.OnAcc).reduce((partialSum, a) => partialSum + a, 0)
    TotalSelfAmt = arr1?.map((item) => item?.SelfAmt).reduce((partialSum, a) => partialSum + a, 0)
    TotalDDDVAmt = arr1?.map((item) => item?.DDDVAmt).reduce((partialSum, a) => partialSum + a, 0)
    TotalValuation = arr1?.map((item) => item?.Valuation).reduce((partialSum, a) => partialSum + a, 0)
    TotalNetAmount = arr1?.map((item) => item?.NetAmount).reduce((partialSum, a) => partialSum + a, 0)
    const heading = { SN: `Received Branch: ${headerData?.selReceivedBranch}`, RecdCityBranch: `Source City: ${headerData?.selSourceCity}`, Valuation: `Received City: ${headerData?.selReceivedCity}`, isHeading: true }
    const subHeading = {
        SN: "Sr\nNo.", VehicleNo: 'Vehicle\nNo.', DriverConductorName: "Driver Name", DriverContactNo: 'Driver No.', BookingBranch: 'Source Branch', DestinationBranch: "Dest. Branch", DispatchedCity: 'Disp. City', DispatchedBranch: "Disp. Branch",
        ReceivedCity: 'Recd. City', ReceivedBranch: "Recd. Branch", NOP: 'Item\nUnits', Freight: 'Frt\nChrg', Cartage: 'Cart\nChrg', Hamali: 'Ham\nChrg', OtherChg: 'Oth\nChrg', ServiceTaxAmount: 'Bkg\nGST',
        Valuation: loginCountryId===2?'Insu.\nChrg':'Val\nChrg', paidAmt: 'Paid\nAmt.', ToPayCod: UseToPayAsCOD===1?'COD Amt.':'ToPay+\nCOD Amt.', FOCAmt: "FOC", OnAcc: 'OnAct\nAmt', SelfAmt: 'Self Bkg.\nAmt.', DDDVAmt: 'DDDV\nAmt.', NetAmount: "Net\nAmt.",
        isSubHeading: true
    }
    arr1.unshift(subHeading)
    arr1.unshift(heading)
    arr1.push({
        SN: `Total: Received Branch:  ${headerData?.selReceivedBranch}`, NOP: TotalNop, Freight: TotalFreight.toFixed(2), Cartage: TotalCartageAmt.toFixed(2), Hamali: TotalHamaliChgs.toFixed(2), OtherChg: TotalOtherChgs.toFixed(2), ServiceTaxAmount: TotalServiceTaxAmount.toFixed(2),
        Valuation: TotalValuation.toFixed(2), paidAmt: TotalpaidAmt.toFixed(2), ToPayCod: TotalToPayCod.toFixed(2), FOCAmt: TotalFOCAmt.toFixed(2), OnAcc: TotalOnAcc.toFixed(2), SelfAmt: TotalSelfAmt.toFixed(2), DDDVAmt: TotalDDDVAmt.toFixed(2), NetAmount: TotalNetAmount.toFixed(2),
        isTotal: true
    })
    return arr1
}
export const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
    const doc = data.doc
    // Footer
    var pageSize = doc.internal.pageSize
    var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

    var str = 'Page : ' + doc.internal.getNumberOfPages()
    if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
    }
    doc.setFontSize(16)
    doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, "right")
    doc.setFont('Roboto', 'bold')
    doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
    doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
}
export const paymentWiseDrawCell = function (data,loginCountryId) {
    var rows = data.table.body
    rows.map((val) => {
        val.cells[1].styles.fillColor = colors[val.raw.PaymentTypeID]
        if (val.raw.isHeading) {
            if (loginCountryId === 2) {
                val.cells[0].colSpan = 4
                val.cells[0].styles.font = 'Roboto'
                val.cells[0].styles.fontStyle = 'normal'
                val.cells[0].styles.fontSize = '16'
                val.cells[0].styles.textColor = [0, 0, 0]
                val.cells[0].styles.halign = 'left'
                val.cells[0].styles.fillColor = [218, 237, 254]
                val.cells[4].colSpan = 3
                val.cells[4].styles.font = 'Roboto'
                val.cells[4].styles.fontStyle = 'normal'
                val.cells[4].styles.fontSize = '16'
                val.cells[4].styles.textColor = [0, 0, 0]
                val.cells[4].styles.halign = 'right'
                val.cells[4].styles.fillColor = [218, 237, 254]
                val.cells[7].colSpan = 2
                val.cells[7].styles.font = 'Roboto'
                val.cells[7].styles.fontStyle = 'normal'
                val.cells[7].styles.fontSize = '17'
                val.cells[7].styles.textColor = [0, 0, 0]
                val.cells[7].styles.halign = 'right'
                val.cells[7].styles.fillColor = [218, 237, 254]
            } else {
                val.cells[0].colSpan = 4
                val.cells[0].styles.font = 'Roboto'
                val.cells[0].styles.fontStyle = 'normal'
                val.cells[0].styles.fontSize = '16'
                val.cells[0].styles.textColor = [0, 0, 0]
                val.cells[0].styles.halign = 'left'
                val.cells[0].styles.fillColor = [218, 237, 254]
                val.cells[4].colSpan = 3
                val.cells[4].styles.font = 'Roboto'
                val.cells[4].styles.fontStyle = 'normal'
                val.cells[4].styles.fontSize = '16'
                val.cells[4].styles.textColor = [0, 0, 0]
                val.cells[4].styles.halign = 'right'
                val.cells[4].styles.fillColor = [218, 237, 254]
                val.cells[7].colSpan = 3
                val.cells[7].styles.font = 'Roboto'
                val.cells[7].styles.fontStyle = 'normal'
                val.cells[7].styles.fontSize = '17'
                val.cells[7].styles.textColor = [0, 0, 0]
                val.cells[7].styles.halign = 'right'
                val.cells[7].styles.fillColor = [218, 237, 254]
            }

        }
        if (val.raw.isSubHeading) {
            if (loginCountryId === 2) {
                for (let i = 0; i <= 8; i++) {
                    val.cells[i].colSpan = 1
                    val.cells[i].styles.font = 'Roboto'
                    val.cells[i].styles.fontStyle = 'normal'
                    val.cells[i].styles.fontSize = '16'
                    val.cells[i].styles.textColor = [0, 0, 0]
                    val.cells[i].styles.halign = i == 0 ? "left" : i == 1 ? "left" : 'right'
                    val.cells[i].styles.fillColor = [233, 245, 255]
                }
            } else {
                for (let i = 0; i <= 9; i++) {
                    val.cells[i].colSpan = 1
                    val.cells[i].styles.font = 'Roboto'
                    val.cells[i].styles.fontStyle = 'normal'
                    val.cells[i].styles.fontSize = '16'
                    val.cells[i].styles.textColor = [0, 0, 0]
                    val.cells[i].styles.halign = i == 0 ? "left" : i == 1 ? "left" : 'right'
                    val.cells[i].styles.fillColor = [233, 245, 255]
                }
            }
            
        }
        if (val.raw.isTotal) {
            val.cells[0].colSpan = 2
            val.cells[0].styles.font = 'Roboto'
            val.cells[0].styles.fontStyle = 'normal'
            val.cells[0].styles.fontS0ze = '16'
            val.cells[0].styles.textColor = [0, 0, 0]
            val.cells[0].styles.halign = 'left'
            val.cells[0].styles.fillColor = [238, 238, 238]
            if (loginCountryId === 2) {
                for (let i = 2; i <= 8; i++) {
                    val.cells[i].colSpan = 1
                    val.cells[i].styles.font = 'Roboto'
                    val.cells[i].styles.fontStyle = 'normal'
                    val.cells[i].styles.fontSize = '16'
                    val.cells[i].styles.textColor = [0, 0, 0]
                    val.cells[i].styles.halign = i == 0 ? "left" : 'right'
                    val.cells[i].styles.fillColor = [238, 238, 238]
                }
            } else {
                for (let i = 2; i <= 9; i++) {
                    val.cells[i].colSpan = 1
                    val.cells[i].styles.font = 'Roboto'
                    val.cells[i].styles.fontStyle = 'normal'
                    val.cells[i].styles.fontSize = '16'
                    val.cells[i].styles.textColor = [0, 0, 0]
                    val.cells[i].styles.halign = i == 0 ? "left" : 'right'
                    val.cells[i].styles.fillColor = [238, 238, 238]
                }
            }
            
        }

    })
}
export const summaryWiseDrawCell = function (data, loginCountryId) {
    var rows = data.table.body
    rows.map((val) => {
        if (val.raw.isHeading) {
            val.cells[0].colSpan = 5
            val.cells[0].styles.font = 'Roboto'
            val.cells[0].styles.fontStyle = 'normal'
            val.cells[0].styles.fontSize = '16'
            val.cells[0].styles.textColor = [0, 0, 0]
            val.cells[0].styles.halign = 'left'
            val.cells[0].styles.fillColor = [218, 237, 254]
            if (loginCountryId === 2) {
            val.cells[5].colSpan =  6
            val.cells[5].styles.font = 'Roboto'
            val.cells[5].styles.fontStyle = 'normal'
            val.cells[5].styles.fontSize = '16'
            val.cells[5].styles.textColor = [0, 0, 0]
            val.cells[5].styles.halign = 'right'
            val.cells[5].styles.fillColor = [218, 237, 254]
            val.cells[11].colSpan = 8
            val.cells[11].styles.font = 'Roboto'
            val.cells[11].styles.fontStyle = 'normal'
            val.cells[11].styles.fontSize = '16'
            val.cells[11].styles.textColor = [0, 0, 0]
            val.cells[11].styles.halign = 'right'
            val.cells[11].styles.fillColor = [218, 237, 254]
            }else{
            val.cells[5].colSpan = 7
            val.cells[5].styles.font = 'Roboto'
            val.cells[5].styles.fontStyle = 'normal'
            val.cells[5].styles.fontSize = '16'
            val.cells[5].styles.textColor = [0, 0, 0]
            val.cells[5].styles.halign = 'right'
            val.cells[5].styles.fillColor = [218, 237, 254]
            val.cells[12].colSpan = 8
            val.cells[12].styles.font = 'Roboto'
            val.cells[12].styles.fontStyle = 'normal'
            val.cells[12].styles.fontSize = '16'
            val.cells[12].styles.textColor = [0, 0, 0]
            val.cells[12].styles.halign = 'right'
            val.cells[12].styles.fillColor = [218, 237, 254]
            }
            
        }
        if (val.raw.isSubHeading) {
            if (loginCountryId === 2) {
                for (let i = 0; i <= 18; i++) {
                    val.cells[i].colSpan = 1
                    val.cells[i].styles.font = 'Roboto'
                    val.cells[i].styles.fontStyle = 'normal'
                    val.cells[i].styles.fontSize = '16'
                    val.cells[i].styles.textColor = [0, 0, 0]
                    val.cells[i].styles.halign = i == 0 || i == 1 || i == 2 || i == 3 || i == 4 || i == 5 ? "left" : 'right'
                    val.cells[i].styles.fillColor = [233, 245, 255]
                }
            } else {
                for (let i = 0; i <= 19; i++) {
                    val.cells[i].colSpan = 1
                    val.cells[i].styles.font = 'Roboto'
                    val.cells[i].styles.fontStyle = 'normal'
                    val.cells[i].styles.fontSize = '16'
                    val.cells[i].styles.textColor = [0, 0, 0]
                    val.cells[i].styles.halign = i == 0 || i == 1 || i == 2 || i == 3 || i == 4 || i == 5 ? "left" : 'right'
                    val.cells[i].styles.fillColor = [233, 245, 255]
                }
            }

        }
        if (val.raw.isTotal) {
            val.cells[0].colSpan = 6
            val.cells[0].styles.font = 'Roboto'
            val.cells[0].styles.fontStyle = 'normal'
            val.cells[0].styles.fontS0ze = '16'
            val.cells[0].styles.textColor = [0, 0, 0]
            val.cells[0].styles.halign = 'right'
            val.cells[0].styles.fillColor = [238, 238, 238]
            if (loginCountryId === 2) {
                for (let i = 5; i <= 18; i++) {
                    val.cells[i].colSpan = 1
                    val.cells[i].styles.font = 'Roboto'
                    val.cells[i].styles.fontStyle = 'normal'
                    val.cells[i].styles.fontSize = '16'
                    val.cells[i].styles.textColor = [0, 0, 0]
                    val.cells[i].styles.halign = i == 0 ? "left" : 'right'
                    val.cells[i].styles.fillColor = [238, 238, 238]
                }
            } else {
                for (let i = 5; i <= 19; i++) {
                    val.cells[i].colSpan = 1
                    val.cells[i].styles.font = 'Roboto'
                    val.cells[i].styles.fontStyle = 'normal'
                    val.cells[i].styles.fontSize = '16'
                    val.cells[i].styles.textColor = [0, 0, 0]
                    val.cells[i].styles.halign = i == 0 ? "left" : 'right'
                    val.cells[i].styles.fillColor = [238, 238, 238]
                }
            }

        }

    })
}

export const DetailWiseDrawCell = function (data, columns, matchFields, selectedFields) {
    var rows = data.table.body
    rows.map((val) => {
        // val.cells[10].styles.fillColor = colors[`${val.raw.PaymentTypeInt}`]
        if (val.raw.isHeading) {
            let prevColSpan = 0;
            for (let key in val.raw) {
                if (key !== 'isHeading') {
                    val.cells[prevColSpan].text = val.raw[key];
                    val.cells[prevColSpan].colSpan = key == "SN" ? columns.length - Math.floor(columns?.length / 3) * 2 : Math.floor(columns?.length / 3);
                    val.cells[prevColSpan].styles.halign = key == "PaymentType" ? "right" : "left"
                    prevColSpan += key == "SN" ? columns.length - Math.floor(columns?.length / 3) * 2 : Math.floor(columns?.length / 3);
                }
            }
        }
        if (val.raw.isTotal) {
            let prevColSpan = 0;
            for (let key in val.raw) {
                if (key == 'SN') {
                    val.cells[prevColSpan].text = val.raw.SN.toString();
                    val.cells[prevColSpan].colSpan = Object.keys(matchFields).length;
                    val.cells[prevColSpan].styles.halign = "right"
                    prevColSpan += Object.keys(matchFields).length;
                }
                else {
                    if (key !== 'isTotal') {
                        if (selectedFields.hasOwnProperty(key)) {
                            val.cells[prevColSpan].text = Number(val.raw[key]).toFixed(2);
                            prevColSpan += 1;
                        }
                    }
                }
            }
        }

    })
}
